export const MAIA_HEADER_LOGO_FILENAME = 'Maia_Logo_1920x867px.png';
export const MAIA_ICON_FILENAME = 'Maia_Logo_Icon_Option_1_FullColor.png';

export const getMaiaHeaderLogoUrl = (env: string, baseUrl: string): string => {
  if (env === 'LOCAL') {
    return `/${MAIA_HEADER_LOGO_FILENAME}`;
  }
  return `${baseUrl}/${MAIA_HEADER_LOGO_FILENAME}`;
};

export const getMaiaIconUrl = (env: string, baseUrl: string): string => {
  if (env === 'LOCAL') {
    return `/${MAIA_ICON_FILENAME}`;
  }
  return `${baseUrl}/${MAIA_ICON_FILENAME}`;
};
